import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import echarts from 'echarts'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import animated from 'animate.css'
import Server from 'common/conf/Server';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
import { preventReClick } from './mixin/preventReClick'



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(preventReClick);
Vue.use(animated);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.component(CollapseTransition.name, CollapseTransition);

import './common/js/common-plugins';
import './assets/css/index.css';
import {hasPermission} from "common/js/common-utils";

Vue.prototype.$echarts = echarts;
Vue.prototype.hasPerm = hasPermission;
Vue.prototype.roleXu =['shenyang','xu'];
Vue.prototype.roleYuan =['shenyang','xu', 'zhou'];
Vue.prototype.roleKefu =['tianxin', 'liuzhongmin', 'shenyang','何华'];
Vue.prototype.roleXue =['xue'];
Vue.prototype.roleDaoC =['hk001','wsn'];//临时解决 部分导出按钮
Vue.prototype.roleTOngDao =['hk001','admin'];//解决通道代码显示问题

// document.title = '乐银付管理平台' + (process.env.NODE_ENV == 'development' ? '-测试' : '');

export const Host = Server[process.env.NODE_ENV];
if (Host === "https://testpos.xinchuangquan.cn:") {
	document.title = '全付宝管理平台-测试'
}
else {
	document.title = '全付宝管理平台'
}
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
});









// WEBPACK FOOTER //
// ./src/main.js